import CanvasObject from './CanvasObject.js';

export default class CanvasInput extends CanvasObject {

  constructor(parent, x, y, width, height, options) {
    super(parent, {
      x,
      y,
      width,
      height,
      draggable: false,
      type: 'custom'
    }, {}, {'skipMeForNearObjs': true, 'skipMeFromPadding': true})

    this.defaultValue = options.defaultValue || "";
    this.text = this.defaultValue;
    this.align = options.align || 'center';
    this.type = options.type || 'text';
    if(this.align === 'right')
      this.carretPos = 0;
    else this.carretPos = this.text.length;
    this.init();
  }

  init() {
    this.on('focus', (e) => {
      this.prevText = this.text.substr(0, this.text.length);
      this.focus = true;
    })
    this.on('unfocus', (e) => {

      if(this.focus)
        this.validateInput();

      this.focus = false;
      if(!this.text.length)
        this.text = this.prevText;
    })
    this.on('keydown', (e) => {
      if(!this.focus) return;
      const key = e.key;
      if(key.toLowerCase() === 'enter') {
        this.callEvent('unfocus', {});
        this.validateInput();
      } else if(key.toLowerCase() === 'backspace') {
        this.text = this.text.substr(0, this.text.length - 1);
        if(this.align === 'left' && this.carretPos > 0)
          this.carretPos--;
      } else {
        if(this.isOk(key)) {
          this.text += key;
          if(this.align === 'left')
            this.carretPos++;
        }
      }
    })
  }

  isOk(key) {
    switch(this.type) {
      case 'text': {
        return key.match(/^.{1}$/g);
      }

      case 'number': {
        return key.match(/^[0-9-+.]{1}$/g);
      }

      default:
        return true;
    }
  }

  getValue() {
    return this.text;
  }

  draw(context) {
    context.save();

    if(this.focus) {
      context.fillStyle = '#292E39';
      context.strokeStyle = '#2E3440'
    } else {
      context.fillStyle = '#00000000';
      context.strokeStyle = '#00000000';
    }

    context.globalCompositeOperation = 'destination-over';
    context.lineWidth = 2;

    context.rect(this.x, this.y, this.width, this.height);
    context.fill();
    context.stroke();

    context.font = '20px Microsoft Yi Baiti'
    context.strokeStyle = '#2E3440';
    context.fillStyle = 'white';
    context.lineWidth = 3;
    context.textAlign = this.align

    context.globalCompositeOperation = 'source-over';

    if(!this.focus) {
      if(this.align === 'right')
        context.fillText(this.text, this.x + this.width, this.y + this.height / 2 + 3);
      else if(this.align === 'center')
        context.fillText(this.text, this.x + this.width / 2, this.y + this.height / 2 + 3);
      else if(this.align === 'left')
        context.fillText(this.text, this.x, this.y + this.height / 2 + 3);
    } else {
      if(this.align === 'right')
        context.fillText(this.text, this.x + this.width - ((this.carretPos + 1) * 10), this.y + this.height / 2 + 3);
      if(this.align === 'left')
        context.fillText(this.text, this.x, this.y + this.height / 2 + 3);

      this.drawCarret(context);
    }

    context.restore();
  }

  validateInput() {
    this.callEvent('validateTyping', {});
  }

  validate() {
    this.callEvent('validate', {});
  }

  updateValue(newValue, timeout = 0) {
    setTimeout(() => {
      if(this.type === 'number')
        newValue = parseFloat(newValue);
      this.text = newValue.toString();
      this.validate();
    }, timeout);
  }

  drawCarret(context) {
    const pos = this.carretPos;
    if(this.align === 'right')
      context.fillText('_', this.x + this.width - (pos * 10), this.y + this.height / 2 + 3);
    else if(this.align === 'left')
      context.fillText('_', this.x + (pos * 10), this.y + this.height / 2 + 3);
  }

}



// WEBPACK FOOTER //
// ./src/components/canvas/objects/CanvasInput.js